import QRCode from "qrcode.react";
import React from "react";

export default function QRCodeGenerator() {
  let QRCodeLink = window.location.href.slice(0, -1) + "show";

  //ttms2.thyteknik.com.tr adresinden gelen isteklerde QRCode olarak safebook.thyteknik.com.tr adresine yönlendirilsin.
  if (window.location.hostname == "ttms2.thyteknik.com.tr") {
    QRCodeLink = QRCodeLink.replace(window.location.hostname, "safebook.thyteknik.com.tr");
  }

  QRCodeLink = QRCodeLink.replace("?", "");

  return (
    <div>
      <br />
      {QRCodeLink != null ? "QR link: " + QRCodeLink : <u>Error occurred while generating QR code</u>}
      <br />
      <br />
      {QRCodeLink != null ? <QRCode value={QRCodeLink} /> : ""}
    </div>
  );
}
